var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3410.36 3269.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2740.59,2748.07c0,110.49-89.89,200.38-200.38,200.38H521.79c-110.49,0-200.38-89.89-200.38-200.38V729.65c0-110.49,89.89-200.38,200.38-200.38h1564.2l321.4-321.41H521.79C233.52,207.86,0,441.56,0,729.65v2018.42c0,288.29,233.72,521.79,521.79,521.79h2018.43c288.39,0,521.79-233.81,521.79-521.79v-1604.6l-321.41,321.4v1283.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2727.07,229.08c-17.44,17.44-1406.24,1406.24-1423.63,1423.63l-133.48,522.23c-10.12,39.6,25.86,75.58,65.46,65.46l522.23-133.48c12.83-12.83,1411.91-1411.91,1423.63-1423.63-7.02-7.02-446.71-446.71-454.21-454.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3316.29,94.07c-125.43-125.43-328.78-125.43-454.21,0l-11.82,11.82,454.21,454.21,11.82-11.82c125.36-125.36,125.49-328.72,0-454.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.376d394b373ef740bedaf9b8aaf76cde.svg";
export { ForwardRef as ReactComponent };